<template>
  <v-col class="my-0 py-0 px-0 px-md-8 pb-15">
    <v-col class="text-start mt-5 mb-3">
      <v-alert text dense color="#8061c2" border="left" class="pl-5">
        <h1 class="title mt-1">Chats con Agentes</h1>
        <p class="desc mt-0 mb-1">Listado de conversaciones entre usuarios y agentes de IA.</p>
      </v-alert>
    </v-col>

    <!-- Barra de búsqueda -->
    <v-row class="mx-3 mb-4">
      <!-- Búsqueda existente -->
      <v-col cols="12" md="3" class="px-0 pr-1">
        <v-text-field v-model="search" color="#8061c2" label="Buscar por usuario o palabra clave"
          append-icon="mdi-magnify" single-line hide-details outlined class="mb-2" @input="onSearch"></v-text-field>
      </v-col>

      <!-- Filtro de fechas -->
      <v-col cols="12" md="3" class="px-1">
        <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y attach
          min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" label="Filtrar por fecha" prepend-inner-icon="mdi-calendar"
              append-icon="mdi-close" @click:append="clearDate" readonly v-bind="attrs" v-on="on" outlined
              hide-details></v-text-field>
          </template>

          <v-date-picker no-title v-model="date" @input="dateMenu = false" @change="onSearch" color="transparent"
            header-color="transparent" elevation="8" class="custom-datepicker"></v-date-picker>
        </v-menu>
      </v-col>

      <!-- Filtro de respuestas erróneas -->
      <v-col cols="12" md="3" class="px-1">
        <v-select v-model="errorFilter" :items="errorFilterOptions" label="Tipo de respuestas" outlined
          @change="onSearch"></v-select>
      </v-col>

      <!-- Ordenamiento -->
      <v-col cols="12" md="3" class="px-1">
        <v-select v-model="orderDirection" :items="orderDirectionOptions" label="Ordenar por fecha" outlined
          hide-details @change="onSearch"></v-select>
      </v-col>
    </v-row>

    <!-- Tabla de datos -->
    <v-data-table :headers="headers" :items="chats" :loading="loading" class="elevation-1 mx-3 px-2 py-4"
      :items-per-page="perPage" :server-items-length="totalFiltered" :page.sync="page" :footer-props="{
        itemsPerPageOptions: [50, 100, 200, 300, -1],
        showFirstLastPage: true
      }" @update:page="onPageChange" @update:items-per-page="changePerPage">
      <!-- Avatar del Agente -->
      <template v-slot:item.agent.avatar="{ item }">
        <v-avatar size="40">
          <v-img :src="item.agent.avatar" v-if="item.agent.avatar"></v-img>
          <v-avatar v-else color="black">
            <v-icon color="white">mdi-robot</v-icon>
          </v-avatar>
        </v-avatar>
      </template>

      <!-- Avatar del Usuario -->
      <template v-slot:item.user.avatar="{ item }">
        <v-avatar size="40">
          <v-img :src="item.user.avatar" v-if="item.user.avatar"></v-img>
          <v-avatar v-else color="grey">
            <v-icon color="white">mdi-account</v-icon>
          </v-avatar>
        </v-avatar>
      </template>

      <!-- Fecha formateada -->
      <template v-slot:item.date="{ item }">
        {{ formatDate(item.date) }}
      </template>

      <!-- Botón para ver mensajes -->
      <template v-slot:item.actions="{ item }">
        <v-icon color="#8061c2" @click="viewMessages(item)">
          mdi-message-text
        </v-icon>
      </template>
    </v-data-table>

    <!-- Chat Messages Modal Component -->
    <chat-messages-modal v-model="showMessagesModal" :item="currentItem" @input="val => showMessagesModal = val" />
  </v-col>
</template>

<script>
import axios from '@/axios.js';
import moment from 'moment';
import ChatMessagesModal from '@/components/partials/admin/ChatMessagesModal.vue';

export default {
  name: 'AgentsChats',

  components: {
    ChatMessagesModal
  },

  data() {
    return {
      chats: [],
      loading: true,
      page: 1,
      perPage: 50,
      totalFiltered: 0,
      search: '',
      showMessagesModal: false,
      currentItem: {},
      date: null,
      errorFilter: 'all',
      orderDirection: 'desc',
      errorFilterOptions: [
        { text: 'Todas las respuestas', value: 'all' },
        { text: 'Erróneas AsistenteQ&A', value: 'errors' }
      ],
      orderDirectionOptions: [
        { text: 'Mayor a menor', value: 'desc' },
        { text: 'Menor a mayor', value: 'asc' }
      ],
      headers: [
        {
          text: 'Usuario',
          value: 'user.avatar',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nombre Usuario',
          value: 'user.name',
          sortable: true

        },
        // {
        //   text: 'Agente',
        //   value: 'agent.avatar',
        //   align: 'center',
        //   sortable: false
        // },
        {
          text: 'Nombre Agente',
          value: 'agent.name',
          sortable: true
        },
        {
          text: 'Total Mensajes',
          value: 'total_messages',
          align: 'center',
          sortable: true
        },
        {
          text: 'Fecha',
          value: 'date',
          sortable: true
        },
        {
          text: 'Acciones',
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ],
      dateMenu: false,
      urlSessionId: null,
      loadingCountry: false,
    };
  },
    // Obtener el ID de la URL
  async created() {this.urlSessionId = parseInt(this.$route.params.id);
    await this.fetchChats();

    if (this.urlSessionId) {
        // Primero buscar en la lista ya cargada
        let chatToOpen = this.chats.find(chat => chat.session_id === this.urlSessionId);

        // Si no está en la página actual, buscarlo directamente por ID
        if (!chatToOpen) {
            try {
                const response = await axios.get('/chats/list', {
                    params: {
                        session_id: this.urlSessionId,
                        per_page: 1
                    }
                });
                const data = response?.data?.chats?.data || [];
                chatToOpen = data.find(chat => chat.session_id === this.urlSessionId) || null;
            } catch (error) {
                console.error('Error buscando chat por session_id:', error);
            }
        }

        if (chatToOpen) {
            this.currentItem = chatToOpen;
            this.showMessagesModal = true;
        }
    }
},
  methods: {
    hasRenderableMessages(chat) {
      if (!chat || !Array.isArray(chat.messages) || chat.messages.length === 0) return false;
      return chat.messages.some(message => typeof message?.message === 'string' && message.message.trim().length > 0);
    },

    async fetchChats() {
      this.loading = true;
      try {
        const errorKeywords = ['Lo siento', 'Perdón', 'Disculpa', 'apologize', 'sorry', 'apologies', 'apologize', 'I am sorry', 'I apologize'];

        const response = await axios.get('/chats/list', {
          params: {
            page: this.page,
            per_page: this.perPage,
            search: this.search,
            date: this.date,
            error_filter: this.errorFilter === 'errors' ? errorKeywords.join('|') : null,
            order_direction: this.orderDirection
          }
        });

        const nonEmptyChats = (response?.data?.chats?.data || []).filter(chat => this.hasRenderableMessages(chat));

        if (this.errorFilter === 'errors') {
          this.chats = nonEmptyChats.filter(chat => {
            return chat.messages.some(message => {
              const messageLower = (message.message || '').toLowerCase();
              const isFromQA = message.from_name?.toLowerCase() === 'asistente q&a';
              return isFromQA && errorKeywords.some(keyword =>
                messageLower.includes(keyword.toLowerCase())
              );
            });
          });
          this.totalFiltered = this.chats.length;
        } else {
          this.chats = nonEmptyChats;
          this.totalFiltered = nonEmptyChats.length;
        }

      } catch (error) {
        console.error('Error fetching chats:', error);
      } finally {
        this.loading = false;
      }
    },

    clearDate() {
      this.date = null;
      this.fetchChats();
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY hh:mm A');
    },

    viewMessages(item) {
      this.currentItem = item;
      this.showMessagesModal = true;
    },

    onSearch() {
      this.page = 1;
      this.fetchChats();
    },

    onPageChange() {
      this.fetchChats();
    },

    changePerPage(newPerPage) {
      this.perPage = newPerPage;
      this.page = 1;
      this.fetchChats();
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 22px !important;
  color: #8061c2;
}

.desc {
  color: #737373;
  font-size: 15px;
}

.v-menu {
  max-width: 290px;
}
</style>
